var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0662 18.1436L10.0595 18.1401L10.0364 18.128C10.0168 18.1176 9.98877 18.1027 9.95297 18.0834C9.88138 18.0448 9.77851 17.9884 9.64882 17.915C9.38955 17.7682 9.02243 17.5531 8.58329 17.2757C7.70695 16.7221 6.53413 15.9142 5.35673 14.8996C3.05559 12.9165 0.5 9.94034 0.5 6.375C0.5 3.2684 3.0184 0.75 6.125 0.75C7.893 0.75 9.46928 1.56547 10.5 2.83947C11.5307 1.56547 13.107 0.75 14.875 0.75C17.9816 0.75 20.5 3.2684 20.5 6.375C20.5 9.94034 17.9444 12.9165 15.6433 14.8996C14.4659 15.9142 13.293 16.7221 12.4167 17.2757C11.9776 17.5531 11.6104 17.7682 11.3512 17.915C11.2215 17.9884 11.1186 18.0448 11.047 18.0834C11.0112 18.1027 10.9832 18.1176 10.9636 18.128L10.9405 18.1401L10.9338 18.1436L10.9316 18.1447C10.6625 18.2875 10.3375 18.2875 10.0691 18.1451L10.0662 18.1436Z",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.d6ad1b4e26c19712fccc30470c6a33d2.svg";
export { ForwardRef as ReactComponent };